import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Input } from "@/components/ui/input";
import axios from "axios";
import { toast } from "react-toastify";

const formSchema = z.object({
  id: z.number(),
  lastName: z.string().min(1, { message: "Le nom est requis." }).optional(),
  firstName: z.string().min(1, { message: "Le prénom est requis." }).optional(),
  email: z.string().email({ message: "Doit être un email valide." }).optional(),
  clinic: z
    .string()
    .min(1, { message: "La clinique est requise" })
    .optional(),
  accountStatus: z.enum(["ACTIF", "INACTIF"]).optional(),
});

const FormAccountModification: React.FC<{
  accountData?: z.infer<typeof formSchema>;
}> = ({ accountData }) => {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: accountData || {},
  });

  function handleSave(data: z.infer<typeof formSchema>) {
    axios.put(`/dashboard/user/${data.id}`, data).then(() => {
      toast(`Le compte avec l'email : ${data.email} a bien été modifié`, {
        position: "top-center",
        autoClose: 2000,
      });
    })
    .catch(error => {
      console.error("Error response:", error.response);
      console.error("Erreur lors de la modification de l'utilisateur:", error);
      toast.error(`Erreur lors de la modification du compte avec l'email : ${data.email}`, {
        position: "top-center",
        autoClose: 2000,
      });
    });
  }
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(handleSave)}>
        <div className="flex justify-around mb-6 mt-6">
          <FormField
            control={form.control}
            name="lastName"
            render={({ field }) => (
              <FormItem className="w-1/4">
                <FormLabel>Nom</FormLabel>
                <FormControl>
                  <Input placeholder="Nom" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="firstName"
            render={({ field }) => (
              <FormItem className="w-1/4">
                <FormLabel>Prénom</FormLabel>
                <FormControl>
                  <Input placeholder="Prenom" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="email"
            render={({ field }) => (
              <FormItem className="w-1/4">
                <FormLabel>E-mail</FormLabel>
                <FormControl>
                  <Input placeholder="nom@mail.fr" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
        <div className="flex justify-around mb-6 mt-6">
          <FormField
            control={form.control}
            name="clinic"
            render={({ field }) => (
              <FormItem className="w-1/4">
                <FormLabel>Etablissement</FormLabel>
                <FormControl>
                  <Input placeholder="Clinique" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="accountStatus"
            render={({ field }) => (
              <FormItem className="w-1/4">
                <FormLabel>Statut</FormLabel>
                <FormControl>
                  <Select
                    onValueChange={field.onChange}
                    defaultValue={field.value}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Sélectionner une option" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem key="ACTIF" value="ACTIF">
                        Activé
                      </SelectItem>
                      <SelectItem key="INACTIF" value="INACTIF">
                        Désactivé
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <div className="w-1/4"></div>
        </div>
        <div className="w-full flex justify-center">
          <Button type="submit" className="mt-6">
            <Save className="mr-2" /> Enregistrer
          </Button>
        </div>
      </form>
    </Form>
  );
};
export default FormAccountModification;
